import { HarvestProofAnswerPublic, HarvestProofParcelStatus } from '../types/harvest-proof';

const LEGACY_PROOF_RECEIVED_STATUSES = new Set([
  HarvestProofParcelStatus.PROOF_RECEIVED,
  'FINISHED',
]);

export function isHarvestProofAnswerSubmitted(
  answer: Pick<HarvestProofAnswerPublic, 'status' | 'server_submitted_at'>,
): boolean {
  if (answer.server_submitted_at) {
    return true;
  }

  return LEGACY_PROOF_RECEIVED_STATUSES.has(answer.status);
}
